var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item_list"},[_c('h2',[_vm._v("\n    PRODUCT\n  ")]),_c('h3',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"item_list_wrap"},[_c('img',{attrs:{"src":require('../assets/' + _vm.list_img),"alt":_vm.alt}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }